"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tokens = require("../utils/props/tokens");
var _variantProp = _interopRequireDefault(require("../utils/props/variantProp"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  /**
   * Used to render the control (i.e. tooltip trigger). If a render function is used it will receive the
   * pressable state and tooltip variant as an argument.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]),
  /**
   * The message. Can be raw text or text components.
   */
  content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  /**
   * Select English or French copy for the accessible label.
   */
  copy: _propTypes.default.oneOf(['en', 'fr']),
  /**
   * Use to place the tooltip in a specific location (only if it fits within viewport).
   */
  position: _propTypes.default.oneOf(['auto', 'above', 'right', 'below', 'left']),
  /**
   * Display tooltip icon button as an inline element.
   */
  inline: _propTypes.default.bool,
  /**
   * Callback function triggered when the tooltip is pressed.
   */
  onPress: _propTypes.default.func,
  /**
   * The `id` of the tooltip button.
   */
  nativeID: _propTypes.default.string,
  /**
   * Set to `true` to open the tooltip on hover
   */
  activateOnHover: _propTypes.default.bool,
  tooltipButtonTokens: (0, _tokens.getTokensPropType)('TooltipButton'),
  tokens: (0, _tokens.getTokensPropType)('Tooltip'),
  variant: _variantProp.default.propType
};
var _default = exports.default = propTypes;